import { ProgressSpinnerMode } from "@angular/material"
import { Observable, of } from "rxjs";
import { HttpEventType } from "@angular/common/http";
import { Injector } from "@angular/core";
import { AlertService } from '../services/alert.service';

export class TransferHttpHelper {
    spinnerMode: ProgressSpinnerMode;
    spinnerProgress: number = 0;

    private _isDownloading: boolean = false;
    get isDownloading(): boolean { return this._isDownloading; }
    set isDownloading(value: boolean) {
        this._isDownloading = value;

        if (this._isDownloading) {
            this.spinnerMode = 'indeterminate';
        }
        else {
            this.spinnerMode = 'determinate';
            this.spinnerProgress = 0;
        }
    }

    private _alert: AlertService;

    constructor(injector: Injector) {
        this._alert = injector.get(AlertService);
        this.isDownloading = false;
    }

    download(method: Observable<any>): Observable<any> {
        this.isDownloading = true;

        return new Observable(observer => {
            method.subscribe(event => {
                // Success
                if (event.type === HttpEventType.DownloadProgress) 
                    this.spinnerProgress = Math.round(100 * event.loaded / event.total);
                else if (event.type === HttpEventType.Response)
                    observer.next(event.body);
            }, err => {
                this._alert.error(err);
                observer.error();
            },
                () => {
                    this.isDownloading = false;
                    observer.complete();
                });
        });
    }

    upload(method: Observable<any>): Observable<any> {
        this.isDownloading = true;

        return new Observable(observer => {
            method.subscribe((event) => {
                // Success
                if (event.type === HttpEventType.UploadProgress) {
                    this.spinnerProgress = Math.round(100 * event.loaded / event.total);
                }
                else if (event.type === HttpEventType.Response) {
                    observer.next(event.body);
                }
            }, err => {
                this._alert.error(err);
                observer.error();
            },
                () => {
                    this.isDownloading = false;
                    observer.complete();
                });
        });
    }
}
